import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";

const ProtectedRoute = ({ children, allowedAuthTypes = [] }) => {
  const { authState } = useAuth();
  const location = useLocation();

  // If not authenticated at all, redirect to login
  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If specific auth types are required, check if the user's type matches
  if (allowedAuthTypes.length > 0 && !allowedAuthTypes.includes(authState.authType)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
